import { Outlet } from 'react-router-dom'

/**
 * Component that displays the container layout\
 * No props
 *
 * @namespace
 * @component
 * @author  Pierre-Yves Léglise <pleglise@pm.me>
 * @example
 * return{
 *  <Layout />
 * }
 * @returns {JSX.Element}
 *
 */
const Layout = () => <Outlet />

export default Layout
